import React from 'react';

interface IProps {
  size?: string;
}

const CloseIcon: React.FC<IProps> = ({ size }) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M2.53464 19.3334L0.667969 17.4667L8.13464 10.0001L0.667969 2.53341L2.53464 0.666748L10.0013 8.13341L17.468 0.666748L19.3346 2.53341L11.868 10.0001L19.3346 17.4667L17.468 19.3334L10.0013 11.8667L2.53464 19.3334Z" fill="#999999"/>
      </svg>
    </>
  );
};

export default CloseIcon;
